/**
 * TanStack Query hooks for `pixel-capi-dual-send-with-dedup-via-event-id`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pixelCapiDualSendWithDedupViaEventIdQueryKeys,
	type CreatePixelCapiDualSendWithDedupViaEventIdBody,
	type ListPixelCapiDualSendWithDedupViaEventIdResponse,
	type PixelCapiDualSendWithDedupViaEventIdRow,
} from "./api";

export function usePixelCapiDualSendWithDedupViaEventIdList(): UseQueryResult<ListPixelCapiDualSendWithDedupViaEventIdResponse, Error> {
	return useQuery({
		queryKey: pixelCapiDualSendWithDedupViaEventIdQueryKeys.list(),
		queryFn: list,
	});
}

export function usePixelCapiDualSendWithDedupViaEventIdCreate(): UseMutationResult<PixelCapiDualSendWithDedupViaEventIdRow, Error, CreatePixelCapiDualSendWithDedupViaEventIdBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pixelCapiDualSendWithDedupViaEventIdQueryKeys.all });
		},
	});
}

export function usePixelCapiDualSendWithDedupViaEventIdDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pixelCapiDualSendWithDedupViaEventIdQueryKeys.all });
		},
	});
}
